module.exports = __webpack_public_path__ + "static/media/logo-c++.83ec43ab.png";